// @ts-strict-ignore
import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const InternalGroupDetails = lazy(() =>
  import("@scenes/InternalGroupDetails").then((module) => ({ default: module.InternalGroupDetailsScene }))
);

export const internalGroupDetailsNRO: NavigationRoutingObject = {
  Component: InternalGroupDetails,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("internal-group-details-nro-heading", "Internal Group Details"),
  pageNameForTracking: () => "Internal Group Details",
  getDeveloperNavigationAllowed: () => {
    return true;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  showInSearchResults: false,
  defaultRoute: "/app_settings/developer_console/internal_groups/:appGroupId",
  shouldShowTertiaryNavigationCallback: (permissionContext) => {
    return permissionContext.hasPermission("appGroup", { permission: "viewInternalUserGroups" });
  },
};
